import { Component, Input } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'modal-cedato-component',
  templateUrl: './modal-cedato.component.html',
  styleUrls: ['./modal-cedato.component.scss'],
})
export class ModalCedatoComponent {
  @Input() public modalHeader: string;
  @Input() public modalBody: string;

  constructor(public sharedService: SharedService) {
    this.modalHeader = '';
    this.modalBody = '';
  }

  close() {
    this.sharedService.navigateAwayConfirmation = false;
    this.sharedService.hideCedatoModal();
  }
}
